import React from 'react';
import { Login } from '../../components';

const Access: React.FC = () => {
  return (
    <>
      <Login />
    </>
  );
};

export default Access;
